import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ShieldCheck, Search, ArrowLeft } from 'lucide-react';
import './CertificateLookup.css';

const CertificateLookup = () => {
  const navigate = useNavigate();
  const [certId, setCertId] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    const trimmedId = certId.trim();
    if (!trimmedId) {
      setError('Будь ласка, введіть код сертифіката');
      return;
    }

    // Redirect to the existing verification page
    navigate(`/verify-certificate/${trimmedId}`);
  };

  return (
    <div className="lookup-container">
      <div className="lookup-card">
        <div className="lookup-header">
          <div className="lookup-icon-box">
            <ShieldCheck size={40} />
          </div>
          <h2>Перевірка сертифіката</h2>
          <p>Введіть унікальний код для підтвердження дійсності документа</p>
        </div>

        <form onSubmit={handleSubmit} className="lookup-form">
          {error && <div className="lookup-error-box">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="certId">Код сертифіката</label>
            <div className="input-with-icon">
              <Search size={18} className="input-icon" />
              <input
                id="certId"
                type="text"
                value={certId}
                onChange={(e) => setCertId(e.target.value)}
                placeholder="Наприклад: cert_a1b2c3d4..."
                autoFocus
                required
              />
            </div>
          </div>

          <button type="submit" className="btn-lookup">
            Перевірити
          </button>
        </form>

        <div className="lookup-footer">
          <Link to="/" className="btn-back">
            <ArrowLeft size={16} />
            <span>Назад до входу</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CertificateLookup;
